import React from 'react'
import {Button, Flex, Text} from '../../vanilla'
import {MealDealContinueBox} from './meal-deal-continue-box'

interface MealDealBuilderControlsProps {
  remainingSteps: number
  mealDealPrice?: string
  onReset?: () => void
  onAddDealToBasket?: () => void
  hasAnySelection?: boolean
}

export const MealDealBuilderControls = ({
  remainingSteps,
  mealDealPrice,
  onReset,
  onAddDealToBasket,
  hasAnySelection
}: MealDealBuilderControlsProps) => {
  const handleReset = () => {
    onReset?.()
  }

  if (!hasAnySelection) {
    return <MealDealContinueBox />
  }

  return (
    <Flex
      width="full"
      backgroundColor="white"
      position={['fixed', 'relative']}
      bottom="0px"
      zIndex="sticky"
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="4px"
      paddingX="20px"
      paddingY="16px"
      marginBottom={['0px', '28px']}
      borderRadius="base"
      style={{
        left: '50%',
        transform: 'translateX(-50%)'
      }}
    >
      {remainingSteps > 0 && (
        <Text variant="text3" style={{color: '#C87700'}}>
          {remainingSteps} step(s) remaining
        </Text>
      )}

      <Button
        size="lg"
        width={['full', 'auto']}
        onClick={onAddDealToBasket}
        data-test-selector="add-all-to-basket"
        disabled={remainingSteps !== 0}
      >
        <Text variant="text3Bold">Add Deal To Basket{mealDealPrice ? `  •  ${mealDealPrice}` : null}</Text>
      </Button>

      <Text
        variant="text3"
        color={{default: 'accent6'}}
        textDecoration="underline"
        marginTop={['12px', '0px']}
        cursor="pointer"
        onClick={handleReset}
      >
        Start Again
      </Text>
    </Flex>
  )
}

export default MealDealBuilderControls
